import { useEffect, useState } from 'react';

import { useEnrollStudentCertificateApi, useGetStudentCertificateApi } from '@/api/mypage.ts';
import FileItem from '@/components/common/Input/InputFile/FileItem.tsx';
import InputFile from '@/components/common/Input/InputFile/InputFile.tsx';
import { useLoadingStore } from '@/store/loadingStore.ts';
import { useToastStore } from '@/store/toastStore.ts';
import { formatBytesToKB } from '@/utils/formatting.ts';

import * as S from './style.ts';

const EnrollmentCert: React.FC = () => {
	const [uploadedFile, setUploadedFile] = useState<File | null>(null);

	const { openToast } = useToastStore();
	const loadingStore = useLoadingStore();

	const { mutateAsync: enrollStudentCertificate } = useEnrollStudentCertificateApi();

	const handleSubmitEnrollment = async () => {
		// + UPDATE API
		if (confirm('재학증명서를 등록하시겠습니까?')) {
			const formData = new FormData();
			uploadedFile && formData.append('file', uploadedFile);

			if (uploadedFile === null) alert('파일을 업로드 후 등록해주세요.');
			try {
				await enrollStudentCertificate(formData);
				openToast({
					icon: 'alert',
					content: '등록되었습니다.',
					showTime: 3000,
				});
				refetchStudentCertificateData();
				setUploadedFile(null);
			} catch (error) {
				console.log(`error : `, error);
				alert('등록에 실패했습니다.');
			}
		}
	};

	// ==============================================================
	// 증명서상태 확인 [START]
	// ==============================================================
	const { data: studentCertificateData, refetch: refetchStudentCertificateData, isFetching: isFetechingStudentCertificate } = useGetStudentCertificateApi();

	// =============================== 증명서상태 확인 [END] ===============================

	useEffect(() => {
		if (isFetechingStudentCertificate) {
			loadingStore.onLoading(); // 로딩 시작
		} else {
			loadingStore.offLoading(); // 로딩 종료
		}
	}, [isFetechingStudentCertificate]);

	return (
		<S.FormContainer>
			<S.Container>
				<S.Title>재학인증</S.Title>
				<S.FormGroup>
					<S.Label htmlFor="files">재학증명서 첨부</S.Label>
					<InputFile file={uploadedFile} setFile={setUploadedFile} />
					{studentCertificateData?.file_pk && (
						<FileItem
							fileName={studentCertificateData?.file_name ?? '이름 없음'}
							fileSize={formatBytesToKB(studentCertificateData?.file_size) ?? '크기 정보 없음'}
							willBeDeletedItem={uploadedFile !== null}
						/>
					)}
				</S.FormGroup>
			</S.Container>
			<S.EditButton onClick={handleSubmitEnrollment} disabled={uploadedFile === null}>
				{'등록'}
			</S.EditButton>
			{studentCertificateData && studentCertificateData.member_student_certificate_yn && studentCertificateData.member_student_certificate_yn !== 'false' && (
				<S.CertState className={studentCertificateData?.member_student_certificate_yn !== '인증 실패' ? 'normal' : 'error'}>
					{studentCertificateData.member_student_certificate_yn}
				</S.CertState>
			)}
		</S.FormContainer>
	);
};

export default EnrollmentCert;
